package com.downdogapp.client

import kotlin.math.PI
import kotlin.math.absoluteValue
import kotlin.math.ceil

class Angle(val degrees: Double) : Comparable<Angle> {

  init {
    check(degrees.isFinite()) { "Angle must be finite" }
  }

  val clampedDegrees: Double
    get() =
      if (degrees >= 0)
        degrees % 360
      else
        (degrees + 360 * ceil(degrees / -360)) % 360

  val clampedRadians get() = (this.clampedDegrees * PI / 180)

  fun clamped() = Angle(clampedDegrees)

  fun abs() = Angle(degrees.absoluteValue)

  operator fun plus(rhs: Angle) = Angle(this.degrees + rhs.degrees)
  operator fun minus(rhs: Angle) = Angle(this.degrees - rhs.degrees)

  override operator fun compareTo(other: Angle) = this.degrees.compareTo(other.degrees)

  override fun toString() = "$degrees degrees"

  override fun equals(other: Any?): Boolean {
    if (this === other) return true
    if (other == null || this::class != other::class) return false

    other as Angle

    if (degrees != other.degrees) return false

    return true
  }

  override fun hashCode(): Int {
    return degrees.hashCode()
  }

  companion object {

    val ZERO = fromDegrees(0.0)

    fun fromMinutes(minutes: Number) = Angle(minutes.toDouble() * 6)
    fun fromDegrees(degrees: Number) = Angle(degrees.toDouble())
    fun fromRadians(radians: Number) = Angle(radians.toDouble() * 180 / PI)
  }
}
